import { useEffect, type CSSProperties } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useGame } from "../../state/GameProvider";
import { Sfx } from "../../fx/sfx";

const SOUND: Record<string, (() => void) | undefined> = {
  hit: Sfx.hit,
  combo: Sfx.combo,
  miss: Sfx.miss,
  win: Sfx.win,
  lose: Sfx.lose,
};

const LABEL: Record<string, string> = {
  hit: "命中",
  combo: "連擊",
  miss: "未中",
  win: "破關",
  lose: "失利",
};

export function FxLayer() {
  const { state, actions } = useGame();
  const fx = state.fx;

  useEffect(() => {
    if (!fx) return;
    SOUND[fx.kind]?.();
    const heavy = fx.kind === "miss" || fx.kind === "win" || fx.kind === "lose";
    if (heavy) document.body.classList.add("shake");
    const clear = setTimeout(() => actions.clearFx(), fx.kind === "win" || fx.kind === "lose" ? 1500 : 950);
    const unshake = setTimeout(() => document.body.classList.remove("shake"), 360);
    return () => {
      clearTimeout(clear);
      clearTimeout(unshake);
      document.body.classList.remove("shake");
    };
  }, [fx, actions]);

  return (
    <div className="fxlayer" aria-hidden>
      <AnimatePresence>
        {fx && fx.kind === "win" && (
          <motion.div
            key={`burst-${fx.id}`}
            className="fx-burst"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            {Array.from({ length: 12 }).map((_, i) => (
              <span key={i} style={{ ["--a"]: `${i * 30}deg` } as CSSProperties} />
            ))}
          </motion.div>
        )}
        {fx && fx.kind !== "win" && (
          <motion.div
            key={fx.id}
            className={`fx-float ${fx.kind}`}
            initial={{ opacity: 0, y: 10, scale: 0.8 }}
            animate={{ opacity: 1, y: -64, scale: 1.12 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <span className="fx-main">{fx.kind === "hit" || fx.kind === "combo" ? `−${fx.amount}` : LABEL[fx.kind]}</span>
            <em>{fx.kind === "combo" ? "連對加勢" : LABEL[fx.kind]}</em>
            <i />
            <i />
            <i />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
